var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5973 5.908C41.3873 2.1 38.3793 0 35.1273 0C31.8753 0 28.8653 2.1 26.6553 5.908L2.11729 48.174C-0.122713 52.068 -0.362713 56.112 1.45729 59.266C3.18929 62.266 6.58729 63.992 10.7853 64H59.4693C63.6733 63.992 67.0773 62.272 68.8033 59.278C70.6133 56.144 70.3693 52.116 68.1333 48.228L43.5973 5.908ZM67.0733 58.278C65.7113 60.638 62.9393 61.994 59.4653 62H10.7873C7.32529 61.994 4.55729 60.632 3.18929 58.266C1.73529 55.746 1.97729 52.432 3.84929 49.174L28.3853 6.912C30.2233 3.744 32.6173 2 35.1273 2C37.6373 2 40.0313 3.744 41.8673 6.912L66.4033 49.226C68.2733 52.478 68.5173 55.778 67.0733 58.278Z",
    fill: "#11183F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.128 40C35.3932 40 35.6476 39.8946 35.8351 39.7071C36.0226 39.5196 36.128 39.2652 36.128 39V19C36.128 18.7348 36.0226 18.4804 35.8351 18.2929C35.6476 18.1054 35.3932 18 35.128 18C34.8628 18 34.6084 18.1054 34.4209 18.2929C34.2334 18.4804 34.128 18.7348 34.128 19V39C34.128 39.2652 34.2334 39.5196 34.4209 39.7071C34.6084 39.8946 34.8628 40 35.128 40ZM35 45C32.794 45 31 46.794 31 49C31 51.206 32.794 53 35 53C37.206 53 39 51.206 39 49C39 46.794 37.206 45 35 45ZM35 51C34.485 50.977 33.9988 50.7562 33.6426 50.3836C33.2863 50.0111 33.0875 49.5155 33.0875 49C33.0875 48.4845 33.2863 47.9889 33.6426 47.6164C33.9988 47.2438 34.485 47.023 35 47C35.515 47.023 36.0012 47.2438 36.3574 47.6164C36.7137 47.9889 36.9125 48.4845 36.9125 49C36.9125 49.5155 36.7137 50.0111 36.3574 50.3836C36.0012 50.7562 35.515 50.977 35 51Z",
    fill: "#11183F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.34c013bf99657b7db5dfe53c5d0d3765.svg";
export { ForwardRef as ReactComponent };